import { gql } from 'graphql-request';
import LoadingIndicator from 'src/components/loadingindicator/LoadingIndicator';
import { useFilminfo } from 'src/lib/client/useFilminfo';
import { useLocationContext } from 'src/lib/contexts/LocationContext';
import { type ILoaderMoviesProps } from 'src/lib/types/filminfo/ILoaderMoviesProps';

import React, { useCallback } from 'react';
import withScrollRestoration, { SupportsScrollRestoration } from "src/lib/client/withScrollRestoration";

//#region [Props]
type UpcomingMoviesLoaderProps = {
    children: React.ReactNode;
} & SupportsScrollRestoration;


//#endregion

//#region [Component]
function UpcomingMoviesLoader({ children, isReadyForScrollRestoration }: UpcomingMoviesLoaderProps) {
    const locContext = useLocationContext();
    const { fiData, fiLoading } = useFilminfo(QUERY, { location: locContext.location ?? "" }, { active: locContext.location !== null });

    // Ref callbacks instead of useEffect: https://tkdodo.eu/blog/ref-callbacks-react-19-and-the-compiler
    const loadedContainer = useCallback((node: HTMLDivElement) => {
        isReadyForScrollRestoration?.(true);
    }, [isReadyForScrollRestoration])


    return <div>
        {fiLoading && <LoadingIndicator size='large' position='InlineCenter' />}
        {!fiLoading && fiData && <div ref={loadedContainer} >
            {React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { movies: fiData.movieQuery?.getUpcomingMovies } as ILoaderMoviesProps);
                }
                return child;
            })}
        </div>}
    </div>;
}

export default withScrollRestoration(UpcomingMoviesLoader, 500);
//#endregion

//#region [Styles]

//#endregion

const QUERY = gql`
query ($location: String) {
	movieQuery {
		getUpcomingMovies(location: $location) {
			__typename
			title
			mainVersionId
			premiere
			isPremiereConfirmed
			showsCount
			isKinoklubb
			sanityIdArt
            sanityImagePosterUrl
            sanityImageWideUrl
		}
	}
}
`;
